module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"form-completion-interaction":"Interaction completed","form-completion-memo":"Memo done","interactions-title":"Interactions"},"fr":{"form-completion-interaction":"Interaction complétée","form-completion-memo":"Mémo traité","interactions-title":"Interactions"}}')
  delete Component.options._Ctor
}
